<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div>
          <h1 class="modalTitle">
            {{ $t('phoneNumberModal.weSentAnEmailButPhoneNumberIsInCorrect') }}
            {{$t('phoneNumberModal.wouldYouLikeToReenterPhoneNumber')}}
          </h1>

          <div
            class="form-group small-label inputStandard"
            :style="{'margin-bottom': isError ? '.2rem' : '1.1rem'}"
          >
            <label v-if="value" :for="'telephone'">{{ $t('phoneNumberModal.telephone')}}</label>
            <input
              :type="'text'"
              class="form-control"
              :name="'telephone'"
              :id="'telephone'"
              @keypress="allowOnlyDigits"
              v-model="value"
              :aria-describedby="'telephone'"
              :placeholder="$t('general.telephone')"
            />
            <span v-if="isError" class="vv-error">{{ $t('phoneNumberModal.telephoneIsRequired') }}</span>
          </div>
        </div>
        <div class="d-flex">
          <button
            @click="$emit('close')"
            class="btn btn-outline-primary btn-block mt-4 mr-2"
          >{{$t('phoneNumberModal.cancel')}}</button>
          <button
            @click="resendSms"
            class="btn btn-primary btn-block mt-4 ml-2"
          >{{$t('phoneNumberModal.send')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { HTTP } from '../http';
export default {
  data() {
    return {
      value: '',
      isError: false
    };
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  beforeMount() {
    HTTP.get('api/app/config').then(res => {
      this.countries = res.data.countries;
      const prefix = this.countries.filter(country => country.country == this.user.country);
      prefix ? (this.value = prefix[0].prefix) : false;
    });
  },
  methods: {
    inputChangedValue(name, value) {
      this.value = value;
    },
    allowOnlyDigits(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 43) {
        event.preventDefault();
      }
    },
    resendSms() {
      this.isError = false;
      if (!this.value) {
        this.isError = true;
        return;
      }
      this.$emit('send', this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 999899;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  z-index: 999999;
  width: 95%;
  max-width: 450px;
  margin: 0px auto;
  padding: 20px 15px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modalTitle {
  margin-top: 0;
  font-size: 20px;
  text-align: center;
}
.modalText {
  text-align: center;
  font-size: 15px;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>